import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'

const { half } = measures

export const rounded = css`
  border-radius: 50px;
`

export const loading = css`
  display: block;
  height: 0;
  width: 0;
`

export const error = css`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  background-color: ${colors.errors.error2};
  border-radius: ${half}px;
`

export const errorIcon = css`
  color: ${colors.white100};
  vertical-align: middle;
  text-align: center;
`
